module.exports = __webpack_public_path__ + "assets/f131a8602deb292d661f2541980cf168.svg";